import { __awaiter } from 'tslib';
import { Component, ViewChild, Input, EventEmitter, ViewEncapsulation, HostListener, Output, Injectable, ɵɵdefineInjectable, TemplateRef, Type, ViewContainerRef, ComponentFactoryResolver, ɵɵinject, Directive, ElementRef, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["arrow"];
const _c1 = function (a0, a1, a2, a3, a4) { return { height: a0, width: a1, left: a2, top: a3, opacity: a4 }; };
const _c2 = ["canvasContent"];
function NgFlowchartStepComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c3 = function (a0, a1) { return { data: a0, id: a1 }; };
const _c4 = function (a0) { return { $implicit: a0 }; };
var NgFlowchart;
(function (NgFlowchart) {
    class Flow {
        constructor(canvas) {
            this.canvas = canvas;
        }
        /**
         * Returns the json representation of this flow
         * @param indent Optional indent to specify for formatting
         */
        toJSON(indent) {
            var _a;
            return JSON.stringify({
                root: (_a = this.canvas.flow.rootStep) === null || _a === void 0 ? void 0 : _a.toJSON()
            }, null, indent);
        }
        /**
         * Create a flow and render it on the canvas from a json string
         * @param json The json string of the flow to render
         */
        upload(json) {
            return __awaiter(this, void 0, void 0, function* () {
                let root = JSON.parse(json).root;
                this.clear();
                yield this.canvas.upload(root);
            });
        }
        /**
         * Returns the root step of the flow chart
         */
        getRoot() {
            return this.canvas.flow.rootStep;
        }
        /**
         * Finds a step in the flow chart by a given id
         * @param id Id of the step to find. By default, the html id of the step
         */
        getStep(id) {
            return this.canvas.flow.allSteps.find(child => child.id == id);
        }
        /**
         * Re-renders the canvas. Generally this should only be used in rare circumstances
         * @param pretty Attempt to recenter the flow in the canvas
         */
        render(pretty) {
            this.canvas.reRender(pretty);
        }
        /**
         * Clears all flow chart, reseting the current canvas
         */
        clear() {
            var _a;
            if ((_a = this.canvas.flow) === null || _a === void 0 ? void 0 : _a.rootStep) {
                this.canvas.flow.rootStep.destroy(true, false);
                this.canvas.reRender();
            }
        }
    }
    NgFlowchart.Flow = Flow;
    class Options {
        constructor() {
            /** The gap (in pixels) between flow steps*/
            this.stepGap = 40;
            /** An inner deadzone radius (in pixels) that will not register the hover icon  */
            this.hoverDeadzoneRadius = 20;
            /** Is the flow sequential? If true, then you will not be able to drag parallel steps */
            this.isSequential = false;
            /** The default root position when dropped. Default is TOP_CENTER */
            this.rootPosition = 'TOP_CENTER';
            /** Should the canvas be centered when a resize is detected? */
            this.centerOnResize = true;
        }
    }
    NgFlowchart.Options = Options;
})(NgFlowchart || (NgFlowchart = {}));

const CONSTANTS = {
    DROP_HOVER_ATTR: 'ngflowchart-drop-hover',
    CANVAS_CONTENT_CLASS: 'ngflowchart-canvas-content',
    CANVAS_CONTENT_ID: 'ngflowchart-canvas-content',
    CANVAS_CLASS: 'ngflowchart-canvas',
    CANVAS_STEP_CLASS: 'ngflowchart-canvas-step',
};

class NgFlowchartArrowComponent {
    constructor() {
        this.opacity = 1;
        this.containerWidth = 0;
        this.containerHeight = 0;
        this.containerLeft = 0;
        this.containerTop = 0;
        //to be applied on left and right edges
        this.padding = 10;
        this.isLeftFlowing = false;
    }
    set position(pos) {
        this._position = pos;
        this.isLeftFlowing = pos.start[0] > pos.end[0];
        //in the case where steps are directly underneath we need some minimum width
        this.containerWidth = Math.abs(pos.start[0] - pos.end[0]) + (this.padding * 2);
        this.containerLeft = Math.min(pos.start[0], pos.end[0]) - this.padding;
        this.containerHeight = Math.abs(pos.start[1] - pos.end[1]);
        this.containerTop = pos.start[1];
        this.updatePath();
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.updatePath();
    }
    hideArrow() {
        this.opacity = .2;
    }
    showArrow() {
        this.opacity = 1;
    }
    updatePath() {
        var _a;
        if (!((_a = this.arrow) === null || _a === void 0 ? void 0 : _a.nativeElement)) {
            return;
        }
        if (this.isLeftFlowing) {
            this.arrow.nativeElement.setAttribute("d", `
        M${this.containerWidth - this.padding},0 
        L${this.containerWidth - this.padding},${this.containerHeight / 2}
        L${this.padding},${this.containerHeight / 2}
        L${this.padding},${this.containerHeight - 4}
      `);
        }
        else {
            this.arrow.nativeElement.setAttribute("d", `
        M${this.padding},0 
        L${this.padding},${this.containerHeight / 2}
        L${this.containerWidth - this.padding},${this.containerHeight / 2}
        L${this.containerWidth - this.padding},${this.containerHeight - 4}
      `);
        }
    }
}
NgFlowchartArrowComponent.ɵfac = function NgFlowchartArrowComponent_Factory(t) { return new (t || NgFlowchartArrowComponent)(); };
NgFlowchartArrowComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgFlowchartArrowComponent, selectors: [["lib-ng-flowchart-arrow"]], viewQuery: function NgFlowchartArrowComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.arrow = _t.first);
    } }, inputs: { position: "position" }, decls: 7, vars: 7, consts: [["xmlns", "http://www.w3.org/2000/svg", 1, "ngflowchart-arrow", 3, "ngStyle"], ["id", "arrowhead", "viewBox", "0 0 10 10", "refX", "3", "refY", "5", "markerWidth", "5", "markerHeight", "5", "orient", "auto", "fill", "grey"], ["d", "M 0 0 L 10 5 L 0 10 z"], ["id", "arrowpath", "fill", "none", "stroke", "grey", "stroke-width", "2", "marker-end", "url(#arrowhead)"], ["id", "arrow"], ["arrow", ""]], template: function NgFlowchartArrowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0)(1, "defs")(2, "marker", 1);
        ɵngcc0.ɵɵelement(3, "path", 2);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(4, "g", 3);
        ɵngcc0.ɵɵelement(5, "path", 4, 5);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction5(1, _c1, ctx.containerHeight + "px", ctx.containerWidth + "px", ctx.containerLeft + "px", ctx.containerTop + "px", ctx.opacity));
    } }, dependencies: [ɵngcc1.NgStyle], styles: ["svg[_ngcontent-%COMP%]{position:absolute;transition:all .2s;z-index:0}"] });
NgFlowchartArrowComponent.ctorParameters = () => [];
NgFlowchartArrowComponent.propDecorators = {
    arrow: [{ type: ViewChild, args: ['arrow',] }],
    position: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgFlowchartArrowComponent, [{
        type: Component,
        args: [{ selector: 'lib-ng-flowchart-arrow', template: "<svg\r\n  xmlns=\"http://www.w3.org/2000/svg\"\r\n  [ngStyle]=\"{\r\n      height: containerHeight+'px',\r\n      width: containerWidth+'px',\r\n      left: containerLeft+'px',\r\n      top: containerTop+'px',\r\n      opacity: opacity\r\n  }\"\r\n  class=\"ngflowchart-arrow\"\r\n>\r\n  <defs>\r\n    <marker\r\n      id=\"arrowhead\"\r\n      viewBox=\"0 0 10 10\"\r\n      refX=\"3\"\r\n      refY=\"5\"\r\n      markerWidth=\"5\"\r\n      markerHeight=\"5\"\r\n      orient=\"auto\"\r\n      fill=\"grey\"\r\n    >\r\n      <path d=\"M 0 0 L 10 5 L 0 10 z\" />\r\n    </marker>\r\n  </defs>\r\n  <g id=\"arrowpath\" fill=\"none\" stroke=\"grey\" stroke-width=\"2\" marker-end=\"url(#arrowhead)\">\r\n    <path id=\"arrow\" #arrow />\r\n  </g>\r\n</svg>\r\n", styles: ["svg{position:absolute;transition:all .2s;z-index:0}"] }]
    }], function () { return []; }, { position: [{
            type: Input
        }], arrow: [{
            type: ViewChild,
            args: ['arrow']
        }] }); })();

class NgFlowchartStepComponent {
    constructor() {
        this.viewInit = new EventEmitter();
        this._currentPosition = [0, 0];
        this._isHidden = false;
        this._children = [];
    }
    onMoveStart(event) {
        if (this.canvas.disabled) {
            return;
        }
        this.hideTree();
        event.dataTransfer.setData('type', 'FROM_CANVAS');
        event.dataTransfer.setData('id', this.nativeElement.id);
        this.drop.dragStep = {
            type: this.type,
            data: this.data,
            instance: this
        };
    }
    onMoveEnd(event) {
        this.showTree();
    }
    init(drop, viewContainer, compFactory) {
        this.drop = drop;
        this.viewContainer = viewContainer;
        this.compFactory = compFactory;
    }
    canDeleteStep() {
        return true;
    }
    canDrop(dropEvent, error) {
        return true;
    }
    getDropPositionsForStep(step) {
        return ['BELOW', 'LEFT', 'RIGHT', 'ABOVE'];
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        if (!this.nativeElement) {
            throw 'Missing canvasContent ViewChild. Be sure to add #canvasContent to your root html element.';
        }
        this.nativeElement.classList.add('ngflowchart-step-wrapper');
        this.nativeElement.setAttribute('draggable', 'true');
        if (this._initPosition) {
            this.zsetPosition(this._initPosition);
        }
        //force id creation if not already there
        this.nativeElement.id = this.id;
        this.viewInit.emit();
    }
    get id() {
        if (this._id == null) {
            this._id = 's' + Date.now();
        }
        return this._id;
    }
    get currentPosition() {
        return this._currentPosition;
    }
    /**
     * Creates and adds a child to this step
     * @param template The template or component type to create
     * @param options Add options
     */
    addChild(pending, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let componentRef = yield this.canvas.createStep(pending);
            this.canvas.addToCanvas(componentRef);
            if (options === null || options === void 0 ? void 0 : options.sibling) {
                this.zaddChildSibling0(componentRef.instance, options === null || options === void 0 ? void 0 : options.index);
            }
            else {
                this.zaddChild0(componentRef.instance);
            }
            this.canvas.flow.allSteps.push(componentRef.instance);
            this.canvas.reRender();
            return componentRef.instance;
        });
    }
    /**
     * Destroys this step component and updates all necessary child and parent relationships
     * @param recursive
     * @param checkCallbacks
     */
    destroy(recursive = true, checkCallbacks = true) {
        if (!checkCallbacks || this.canDeleteStep()) {
            let parentIndex;
            if (this._parent) {
                parentIndex = this._parent.removeChild(this);
            }
            this.destroy0(parentIndex, recursive);
            this.canvas.reRender();
            return true;
        }
        return false;
    }
    /**
     * Remove a child from this step. Returns the index at which the child was found or -1 if not found.
     * @param childToRemove Step component to remove
     */
    removeChild(childToRemove) {
        if (!this.children) {
            return -1;
        }
        const i = this.children.findIndex(child => child.id == childToRemove.id);
        if (i > -1) {
            this.children.splice(i, 1);
        }
        return i;
    }
    /**
     * Re-parent this step
     * @param newParent The new parent for this step
     * @param force Force the re-parent if a parent already exists
     */
    setParent(newParent, force = false) {
        if (this.parent && !force) {
            console.warn('This child already has a parent, use force if you know what you are doing');
            return;
        }
        this._parent = newParent;
        if (!this._parent && this.arrow) {
            this.arrow.destroy();
            this.arrow = null;
        }
    }
    /**
     * Called when no longer trying to drop or move a step adjacent to this one
     * @param position Position to render the icon
     */
    clearHoverIcons() {
        this.nativeElement.removeAttribute(CONSTANTS.DROP_HOVER_ATTR);
    }
    /**
     * Called when a step is trying to be dropped or moved adjacent to this step.
     * @param position Position to render the icon
     */
    showHoverIcon(position) {
        this.nativeElement.setAttribute(CONSTANTS.DROP_HOVER_ATTR, position.toLowerCase());
    }
    /**
     * Is this the root element of the tree
     */
    isRootElement() {
        return !this.parent;
    }
    /**
     * Does this step have any children?
     * @param count Optional count of children to check. Defaults to 1. I.E has at least 1 child.
     */
    hasChildren(count = 1) {
        return this.children && this.children.length >= count;
    }
    /** Array of children steps for this step */
    get children() {
        return this._children;
    }
    /** The parent step of this step */
    get parent() {
        return this._parent;
    }
    /**
     * Returns the total width extent (in pixels) of this node tree
     * @param stepGap The current step gap for the flow canvas
     */
    getNodeTreeWidth(stepGap) {
        const currentNodeWidth = this.nativeElement.getBoundingClientRect().width;
        if (!this.hasChildren()) {
            return this.nativeElement.getBoundingClientRect().width;
        }
        let childWidth = this._children.reduce((childTreeWidth, child) => {
            return childTreeWidth += child.getNodeTreeWidth(stepGap);
        }, 0);
        childWidth += stepGap * (this._children.length - 1);
        return Math.max(currentNodeWidth, childWidth);
    }
    /**
     * Is this step currently hidden and unavailable as a drop location
     */
    isHidden() {
        return this._isHidden;
    }
    /**
     * Return current rect of this step. The position can be animated so getBoundingClientRect cannot
     * be reliable for positions
     * @param canvasRect Optional canvasRect to provide to offset the values
     */
    getCurrentRect(canvasRect) {
        let clientRect = this.nativeElement.getBoundingClientRect();
        return {
            bottom: this._currentPosition[1] + clientRect.height + ((canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.top) || 0),
            left: this._currentPosition[0] + ((canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.left) || 0),
            height: clientRect.height,
            width: clientRect.width,
            right: this._currentPosition[0] + clientRect.width + ((canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.left) || 0),
            top: this._currentPosition[1] + ((canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.top) || 0)
        };
    }
    /**
     * Returns the JSON representation of this flow step
     */
    toJSON() {
        return {
            id: this.id,
            type: this.type,
            data: this.data,
            children: this.hasChildren() ? this._children.map(child => {
                return child.toJSON();
            }) : []
        };
    }
    /** The native HTMLElement of this step */
    get nativeElement() {
        var _a;
        return (_a = this.view) === null || _a === void 0 ? void 0 : _a.nativeElement;
    }
    setId(id) {
        this._id = id;
    }
    zsetPosition(pos, offsetCenter = false) {
        if (!this.view) {
            console.warn('Trying to set position before view init');
            //save pos and set in after view init
            this._initPosition = [...pos];
            return;
        }
        let adjustedX = pos[0] - (offsetCenter ? this.nativeElement.offsetWidth / 2 : 0);
        let adjustedY = pos[1] - (offsetCenter ? this.nativeElement.offsetHeight / 2 : 0);
        this.nativeElement.style.left = `${adjustedX}px`;
        this.nativeElement.style.top = `${adjustedY}px`;
        this._currentPosition = [adjustedX, adjustedY];
    }
    zaddChild0(newChild) {
        if (newChild._parent) {
            newChild._parent.removeChild(newChild);
        }
        if (this.hasChildren()) {
            if (newChild.hasChildren()) {
                //if we have children and the child has children we need to confirm the child doesnt have multiple children at any point
                let newChildLastChild = newChild.findLastSingleChild();
                if (!newChildLastChild) {
                    console.error('Invalid move. A node cannot have multiple parents');
                    return false;
                }
                //move the this nodes children to last child of the step arg
                newChildLastChild.setChildren(this._children.slice());
            }
            else {
                //move adjacent's children to newStep
                newChild.setChildren(this._children.slice());
            }
        }
        //finally reset this nodes to children to the single new child
        this.setChildren([newChild]);
        return true;
    }
    zaddChildSibling0(child, index) {
        if (child._parent) {
            child._parent.removeChild(child);
        }
        if (!this.children) {
            this._children = [];
        }
        if (index == null) {
            this.children.push(child);
        }
        else {
            this.children.splice(index, 0, child);
        }
        //since we are adding a new child here, it is safe to force set the parent
        child.setParent(this, true);
    }
    zdrawArrow(start, end) {
        if (!this.arrow) {
            this.createArrow();
        }
        this.arrow.instance.position = {
            start: start,
            end: end
        };
    }
    ////////////////////////
    // PRIVATE IMPL
    destroy0(parentIndex, recursive = true) {
        this.compRef.destroy();
        // //remove from master array
        let index = this.canvas.flow.allSteps.findIndex(ele => ele.id == this.id);
        if (index >= 0) {
            this.canvas.flow.allSteps.splice(index, 1);
        }
        if (this.isRootElement()) {
            this.canvas.flow.rootStep = null;
        }
        if (this.hasChildren()) {
            //this was the root node
            if (this.isRootElement()) {
                if (!recursive) {
                    let newRoot = this._children[0];
                    //set first child as new root
                    this.canvas.flow.rootStep = newRoot;
                    newRoot.setParent(null, true);
                    //make previous siblings children of the new root
                    if (this.hasChildren(2)) {
                        for (let i = 1; i < this._children.length; i++) {
                            let child = this._children[i];
                            child.setParent(newRoot, true);
                            newRoot._children.push(child);
                        }
                    }
                }
            }
            //update children
            let length = this._children.length;
            for (let i = 0; i < length; i++) {
                let child = this._children[i];
                if (recursive) {
                    child.destroy0(null, true);
                }
                //not the original root node
                else if (!!this._parent) {
                    this._parent._children.splice(i + parentIndex, 0, child);
                    child.setParent(this._parent, true);
                }
            }
            this.setChildren([]);
        }
        this._parent = null;
    }
    createArrow() {
        const factory = this.compFactory.resolveComponentFactory(NgFlowchartArrowComponent);
        this.arrow = this.viewContainer.createComponent(factory);
        this.nativeElement.parentElement.appendChild(this.arrow.location.nativeElement);
    }
    hideTree() {
        this._isHidden = true;
        this.nativeElement.style.opacity = '.4';
        if (this.arrow) {
            this.arrow.instance.hideArrow();
        }
        if (this.hasChildren()) {
            this._children.forEach(child => {
                child.hideTree();
            });
        }
    }
    showTree() {
        this._isHidden = false;
        if (this.arrow) {
            this.arrow.instance.showArrow();
        }
        this.nativeElement.style.opacity = '1';
        if (this.hasChildren()) {
            this._children.forEach(child => {
                child.showTree();
            });
        }
    }
    findLastSingleChild() {
        //two or more children means we have no single child
        if (this.hasChildren(2)) {
            return null;
        }
        //if one child.. keep going down the tree until we find no children or 2 or more
        else if (this.hasChildren()) {
            return this._children[0].findLastSingleChild();
        }
        //if no children then this is the last single child
        else
            return this;
    }
    setChildren(children) {
        this._children = children;
        this.children.forEach(child => {
            child.setParent(this, true);
        });
    }
}
NgFlowchartStepComponent.ɵfac = function NgFlowchartStepComponent_Factory(t) { return new (t || NgFlowchartStepComponent)(); };
NgFlowchartStepComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgFlowchartStepComponent, selectors: [["ng-flowchart-step"]], viewQuery: function NgFlowchartStepComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.view = _t.first);
    } }, hostBindings: function NgFlowchartStepComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dragstart", function NgFlowchartStepComponent_dragstart_HostBindingHandler($event) { return ctx.onMoveStart($event); })("dragend", function NgFlowchartStepComponent_dragend_HostBindingHandler($event) { return ctx.onMoveEnd($event); });
    } }, inputs: { data: "data", type: "type", canvas: "canvas", compRef: "compRef", contentTemplate: "contentTemplate" }, outputs: { viewInit: "viewInit" }, decls: 3, vars: 8, consts: [[3, "id"], ["canvasContent", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function NgFlowchartStepComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, NgFlowchartStepComponent_ng_container_2_Template, 1, 0, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(6, _c4, ɵngcc0.ɵɵpureFunction2(3, _c3, ctx.data, ctx.id)));
    } }, dependencies: [ɵngcc1.NgTemplateOutlet], styles: [".ngflowchart-canvas{overflow:auto}.ngflowchart-canvas-content{min-height:100%;min-width:100%;position:relative}.ngflowchart-step-wrapper{box-sizing:border-box;cursor:-webkit-grab;cursor:grab;height:auto;position:absolute;transition:all .2s;width:auto}.ngflowchart-step-wrapper[ngflowchart-drop-hover]:before{background:#8b0000;border-radius:100%;content:\"\";height:12px;position:absolute;width:12px;z-index:1}.ngflowchart-step-wrapper[ngflowchart-drop-hover]:after{-webkit-animation:backgroundOpacity 2s linear infinite;animation:backgroundOpacity 2s linear infinite;background:#c07b7b;border-radius:100%;content:\"\";height:20px;position:absolute;width:20px;z-index:0}.ngflowchart-step-wrapper[ngflowchart-drop-hover=above]:after,.ngflowchart-step-wrapper[ngflowchart-drop-hover=above]:before{right:50%;top:0;transform:translate(50%,-50%)}.ngflowchart-step-wrapper[ngflowchart-drop-hover=below]:after,.ngflowchart-step-wrapper[ngflowchart-drop-hover=below]:before{bottom:0;right:50%;transform:translate(50%,50%)}.ngflowchart-step-wrapper[ngflowchart-drop-hover=right]:after,.ngflowchart-step-wrapper[ngflowchart-drop-hover=right]:before{right:0;top:50%;transform:translate(50%,-50%)}.ngflowchart-step-wrapper[ngflowchart-drop-hover=left]:after,.ngflowchart-step-wrapper[ngflowchart-drop-hover=left]:before{left:0;top:50%;transform:translate(-50%,-50%)}@-webkit-keyframes wiggle{0%{border:2px solid red;transform:translateX(0)}25%{transform:translateX(-10px)}50%{transform:translateX(0)}75%{transform:translateX(10px)}to{border:2px solid red;transform:translateX(0)}}@keyframes wiggle{0%{border:2px solid red;transform:translateX(0)}25%{transform:translateX(-10px)}50%{transform:translateX(0)}75%{transform:translateX(10px)}to{border:2px solid red;transform:translateX(0)}}@-webkit-keyframes backgroundOpacity{0%{opacity:.8}50%{opacity:.3}to{opacity:.8}}@keyframes backgroundOpacity{0%{opacity:.8}50%{opacity:.3}to{opacity:.8}}"], encapsulation: 2 });
NgFlowchartStepComponent.ctorParameters = () => [];
NgFlowchartStepComponent.propDecorators = {
    onMoveStart: [{ type: HostListener, args: ['dragstart', ['$event'],] }],
    onMoveEnd: [{ type: HostListener, args: ['dragend', ['$event'],] }],
    view: [{ type: ViewChild, args: ['canvasContent',] }],
    data: [{ type: Input }],
    type: [{ type: Input }],
    canvas: [{ type: Input }],
    compRef: [{ type: Input }],
    viewInit: [{ type: Output }],
    contentTemplate: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgFlowchartStepComponent, [{
        type: Component,
        args: [{ selector: 'ng-flowchart-step', template: "<div #canvasContent [id]=\"id\">\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      contentTemplate;\r\n      context: {\r\n        $implicit: {\r\n          data: data,\r\n          id: id\r\n        }\r\n      }\r\n    \"\r\n  >\r\n  </ng-container>\r\n</div>\r\n", encapsulation: ViewEncapsulation.None, styles: [".ngflowchart-canvas{overflow:auto}.ngflowchart-canvas-content{min-height:100%;min-width:100%;position:relative}.ngflowchart-step-wrapper{box-sizing:border-box;cursor:-webkit-grab;cursor:grab;height:auto;position:absolute;transition:all .2s;width:auto}.ngflowchart-step-wrapper[ngflowchart-drop-hover]:before{background:#8b0000;border-radius:100%;content:\"\";height:12px;position:absolute;width:12px;z-index:1}.ngflowchart-step-wrapper[ngflowchart-drop-hover]:after{-webkit-animation:backgroundOpacity 2s linear infinite;animation:backgroundOpacity 2s linear infinite;background:#c07b7b;border-radius:100%;content:\"\";height:20px;position:absolute;width:20px;z-index:0}.ngflowchart-step-wrapper[ngflowchart-drop-hover=above]:after,.ngflowchart-step-wrapper[ngflowchart-drop-hover=above]:before{right:50%;top:0;transform:translate(50%,-50%)}.ngflowchart-step-wrapper[ngflowchart-drop-hover=below]:after,.ngflowchart-step-wrapper[ngflowchart-drop-hover=below]:before{bottom:0;right:50%;transform:translate(50%,50%)}.ngflowchart-step-wrapper[ngflowchart-drop-hover=right]:after,.ngflowchart-step-wrapper[ngflowchart-drop-hover=right]:before{right:0;top:50%;transform:translate(50%,-50%)}.ngflowchart-step-wrapper[ngflowchart-drop-hover=left]:after,.ngflowchart-step-wrapper[ngflowchart-drop-hover=left]:before{left:0;top:50%;transform:translate(-50%,-50%)}@-webkit-keyframes wiggle{0%{border:2px solid red;transform:translateX(0)}25%{transform:translateX(-10px)}50%{transform:translateX(0)}75%{transform:translateX(10px)}to{border:2px solid red;transform:translateX(0)}}@keyframes wiggle{0%{border:2px solid red;transform:translateX(0)}25%{transform:translateX(-10px)}50%{transform:translateX(0)}75%{transform:translateX(10px)}to{border:2px solid red;transform:translateX(0)}}@-webkit-keyframes backgroundOpacity{0%{opacity:.8}50%{opacity:.3}to{opacity:.8}}@keyframes backgroundOpacity{0%{opacity:.8}50%{opacity:.3}to{opacity:.8}}"] }]
    }], function () { return []; }, { viewInit: [{
            type: Output
        }], onMoveStart: [{
            type: HostListener,
            args: ['dragstart', ['$event']]
        }], onMoveEnd: [{
            type: HostListener,
            args: ['dragend', ['$event']]
        }], view: [{
            type: ViewChild,
            args: ['canvasContent']
        }], data: [{
            type: Input
        }], type: [{
            type: Input
        }], canvas: [{
            type: Input
        }], compRef: [{
            type: Input
        }], contentTemplate: [{
            type: Input
        }] }); })();

class OptionsService {
    constructor() {
        this._options = new NgFlowchart.Options();
    }
    setOptions(options) {
        this._options = this.sanitizeOptions(options);
    }
    setCallbacks(callbacks) {
        this._callbacks = callbacks;
    }
    get options() {
        return this._options;
    }
    get callbacks() {
        return this._callbacks;
    }
    sanitizeOptions(options) {
        const defaultOpts = new NgFlowchart.Options();
        options = Object.assign(Object.assign({}, defaultOpts), options);
        options.stepGap = Math.max(options.stepGap, 20) || 40;
        options.hoverDeadzoneRadius = Math.max(options.hoverDeadzoneRadius, 0) || 20;
        return options;
    }
}
OptionsService.ɵfac = function OptionsService_Factory(t) { return new (t || OptionsService)(); };
OptionsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: OptionsService, factory: OptionsService.ɵfac });
OptionsService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OptionsService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class CanvasRendererService {
    constructor(options) {
        this.options = options;
    }
    init(viewContainer) {
        this.viewContainer = viewContainer;
    }
    renderRoot(step, dragEvent) {
        this.getCanvasContentElement().appendChild((step.location.nativeElement));
        this.setRootPosition(step.instance, dragEvent);
    }
    renderNonRoot(step, dragEvent) {
        this.getCanvasContentElement().appendChild((step.location.nativeElement));
    }
    updatePosition(step, dragEvent) {
        const relativeXY = this.getRelativeXY(dragEvent);
        step.zsetPosition(relativeXY, true);
    }
    renderChildTree(rootNode, rootRect, canvasRect) {
        //the rootNode passed in is already rendered. just need to render its children /subtree
        if (!rootNode.hasChildren()) {
            return;
        }
        //top of the child row is simply the relative bottom of the root + stepGap
        const childYTop = (rootRect.bottom - canvasRect.top) + this.options.options.stepGap;
        const rootXCenter = (rootRect.left - canvasRect.left) + (rootRect.width / 2);
        //get the width of the child trees
        let childTreeWidths = {};
        let totalTreeWidth = 0;
        rootNode.children.forEach(child => {
            let totalChildWidth = child.getNodeTreeWidth(this.options.options.stepGap);
            childTreeWidths[child.nativeElement.id] = totalChildWidth;
            totalTreeWidth += totalChildWidth;
        });
        //add length for stepGaps between child trees
        totalTreeWidth += (rootNode.children.length - 1) * this.options.options.stepGap;
        //if we have more than 1 child, we want half the extent on the left and half on the right
        let leftXTree = rootXCenter - (totalTreeWidth / 2);
        rootNode.children.forEach(child => {
            let childExtent = childTreeWidths[child.nativeElement.id];
            let childLeft = leftXTree + (childExtent / 2) - (child.nativeElement.offsetWidth / 2);
            child.zsetPosition([childLeft, childYTop]);
            const currentChildRect = child.getCurrentRect(canvasRect);
            child.zdrawArrow([rootXCenter, (rootRect.bottom - canvasRect.top)], [currentChildRect.left + currentChildRect.width / 2 - canvasRect.left, currentChildRect.top - canvasRect.top]);
            this.renderChildTree(child, currentChildRect, canvasRect);
            leftXTree += childExtent + this.options.options.stepGap;
        });
    }
    render(flow, pretty) {
        if (!flow.hasRoot()) {
            return;
        }
        const canvasRect = this.getCanvasContentElement().getBoundingClientRect();
        if (pretty) {
            //this will place the root at the top center of the canvas and render from there
            this.setRootPosition(flow.rootStep, null);
        }
        this.renderChildTree(flow.rootStep, flow.rootStep.getCurrentRect(canvasRect), canvasRect);
        this.adjustDimensions(flow, canvasRect);
    }
    adjustDimensions(flow, canvasRect) {
        let maxRight = 0;
        let maxBottom = 0;
        //TODO this can be better
        flow.allSteps.forEach(ele => {
            let rect = ele.getCurrentRect(canvasRect);
            maxRight = Math.max(rect.right, maxRight);
            maxBottom = Math.max(rect.bottom, maxBottom);
        });
        const widthDiff = canvasRect.width - (maxRight - canvasRect.left);
        if (widthDiff < 100) {
            this.getCanvasContentElement().style.width = `${canvasRect.width + 200}px`;
            if (this.options.options.centerOnResize) {
                //if we add width, rerender canvas in the middle
                this.render(flow, true);
            }
        }
        const heightDiff = canvasRect.height - (maxBottom - canvasRect.top);
        if (heightDiff < 100) {
            this.getCanvasContentElement().style.height = `${canvasRect.height + 200}px`;
        }
    }
    findDropLocationForHover(absMouseXY, targetStep, droppingStep) {
        const stepRect = targetStep.nativeElement.getBoundingClientRect();
        const yStepCenter = stepRect.bottom - stepRect.height / 2;
        const xStepCenter = stepRect.left + stepRect.width / 2;
        const yDiff = absMouseXY[1] - yStepCenter;
        const xDiff = absMouseXY[0] - xStepCenter;
        const absYDistance = Math.abs(yDiff);
        const absXDistance = Math.abs(xDiff);
        //#math class #Pythagoras
        const distance = Math.sqrt(absYDistance * absYDistance + absXDistance * absXDistance);
        const accuracyRadius = (stepRect.height + stepRect.width) / 2;
        let result = null;
        if (distance < accuracyRadius) {
            if (distance < this.options.options.hoverDeadzoneRadius) {
                //basically we are too close to the middle to accurately predict what position they want
                result = 'deadzone';
            }
            if (absYDistance > absXDistance) {
                result = {
                    step: targetStep,
                    position: yDiff > 0 ? 'BELOW' : 'ABOVE',
                    proximity: absYDistance
                };
            }
            else if (!this.options.options.isSequential && !targetStep.isRootElement()) {
                result = {
                    step: targetStep,
                    position: xDiff > 0 ? 'RIGHT' : 'LEFT',
                    proximity: absXDistance
                };
            }
        }
        if (result && result !== 'deadzone') {
            if (!targetStep.getDropPositionsForStep(droppingStep).includes(result.position)) {
                //we had a valid drop but the target step doesnt allow this location
                result = null;
            }
        }
        return result;
    }
    findAndShowClosestDrop(dragStep, event, steps) {
        if (!steps || steps.length == 0) {
            return;
        }
        //because we arent actually dropping anything just use absolute x,y for everything
        const absXY = [event.clientX, event.clientY];
        let bestMatch = null;
        for (let i = 0; i < steps.length; i++) {
            const step = steps[i];
            if (step.isHidden()) {
                continue;
            }
            const position = this.findDropLocationForHover(absXY, step, dragStep);
            if (position) {
                if (position == 'deadzone') {
                    bestMatch = null;
                    break;
                }
                //if this step is closer than previous best match then we have a new best
                else if (bestMatch == null || bestMatch.proximity > position.proximity) {
                    bestMatch = position;
                }
            }
        }
        //TODO make this more efficient. two loops
        steps.forEach(step => {
            if (bestMatch == null || step.nativeElement.id !== bestMatch.step.nativeElement.id) {
                step.clearHoverIcons();
            }
        });
        if (!bestMatch) {
            return;
        }
        bestMatch.step.showHoverIcon(bestMatch.position);
        return {
            step: bestMatch.step,
            position: bestMatch.position
        };
    }
    showSnaps(dragStep) {
    }
    clearAllSnapIndicators(steps) {
        steps.forEach(step => step.clearHoverIcons());
    }
    setRootPosition(step, dragEvent) {
        if (!dragEvent) {
            const canvasTop = this.getCanvasTopCenterPosition();
            step.zsetPosition(canvasTop, true);
            return;
        }
        switch (this.options.options.rootPosition) {
            case 'CENTER':
                const canvasCenter = this.getCanvasCenterPosition();
                step.zsetPosition(canvasCenter, true);
                return;
            case 'TOP_CENTER':
                const canvasTop = this.getCanvasTopCenterPosition();
                step.zsetPosition(canvasTop, true);
                return;
            default:
                const relativeXY = this.getRelativeXY(dragEvent);
                step.zsetPosition(relativeXY, true);
                return;
        }
    }
    getRelativeXY(dragEvent) {
        const canvasRect = this.getCanvasContentElement().getBoundingClientRect();
        return [
            dragEvent.clientX - canvasRect.left,
            dragEvent.clientY - canvasRect.top
        ];
    }
    getCanvasTopCenterPosition() {
        const canvasRect = this.getCanvasContentElement().getBoundingClientRect();
        return [
            canvasRect.width / 2,
            100 //100 is a magic number somewhat. Should be getting from dropped element height instead
        ];
    }
    getCanvasCenterPosition() {
        const canvasRect = this.getCanvasContentElement().getBoundingClientRect();
        return [
            canvasRect.width / 2,
            canvasRect.height / 2
        ];
    }
    getCanvasContentElement() {
        const canvas = this.viewContainer.element.nativeElement;
        let canvasContent = canvas.getElementsByClassName(CONSTANTS.CANVAS_CONTENT_CLASS).item(0);
        return canvasContent;
    }
}
CanvasRendererService.ɵfac = function CanvasRendererService_Factory(t) { return new (t || CanvasRendererService)(ɵngcc0.ɵɵinject(OptionsService)); };
CanvasRendererService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CanvasRendererService, factory: CanvasRendererService.ɵfac });
CanvasRendererService.ctorParameters = () => [
    { type: OptionsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CanvasRendererService, [{
        type: Injectable
    }], function () { return [{ type: OptionsService }]; }, null); })();

class DropDataService {
    constructor() {
    }
    setDragStep(ref) {
        this.dragStep = ref;
    }
    getDragStep() {
        return this.dragStep;
    }
}
DropDataService.ɵfac = function DropDataService_Factory(t) { return new (t || DropDataService)(); };
DropDataService.ɵprov = ɵɵdefineInjectable({ factory: function DropDataService_Factory() { return new DropDataService(); }, token: DropDataService, providedIn: "root" });
DropDataService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class NgFlowchartStepRegistry {
    constructor() {
        this.registry = new Map();
    }
    /**
     * Register a step implementation. Only needed if you are uploading a flow from json
     * @param type The unique type of the step
     * @param step The step templateRef or component type to create for this key
     */
    registerStep(type, step) {
        this.registry.set(type, step);
    }
    getStepImpl(type) {
        return this.registry.get(type);
    }
}
NgFlowchartStepRegistry.ɵfac = function NgFlowchartStepRegistry_Factory(t) { return new (t || NgFlowchartStepRegistry)(); };
NgFlowchartStepRegistry.ɵprov = ɵɵdefineInjectable({ factory: function NgFlowchartStepRegistry_Factory() { return new NgFlowchartStepRegistry(); }, token: NgFlowchartStepRegistry, providedIn: "root" });
NgFlowchartStepRegistry.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgFlowchartStepRegistry, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * This service handles adding new steps to the canvas
 */
class StepManagerService {
    constructor(componentFactoryResolver, registry) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.registry = registry;
    }
    init(viewContainer) {
        this.viewContainer = viewContainer;
    }
    createFromRegistry(id, type, data, canvas) {
        let templateComp = this.registry.getStepImpl(type);
        let compRef;
        if (templateComp instanceof TemplateRef || templateComp instanceof Type) {
            compRef = this.create({
                template: templateComp,
                type: type,
                data: data
            }, canvas);
        }
        else {
            throw 'Invalid registry implementation found for type ' + type;
        }
        compRef.instance.setId(id);
        return compRef;
    }
    create(pendingStep, canvas) {
        let componentRef;
        if (pendingStep.template instanceof TemplateRef) {
            const factory = this.componentFactoryResolver.resolveComponentFactory(NgFlowchartStepComponent);
            componentRef = this.viewContainer.createComponent(factory);
            componentRef.instance.contentTemplate = pendingStep.template;
        }
        else {
            const factory = this.componentFactoryResolver.resolveComponentFactory(pendingStep.template);
            componentRef = this.viewContainer.createComponent(factory);
        }
        componentRef.instance.data = pendingStep.data;
        componentRef.instance.type = pendingStep.type;
        componentRef.instance.canvas = canvas;
        componentRef.instance.compRef = componentRef;
        componentRef.instance.init(componentRef.injector.get(DropDataService), componentRef.injector.get(ViewContainerRef), componentRef.injector.get(ComponentFactoryResolver));
        return componentRef;
    }
}
StepManagerService.ɵfac = function StepManagerService_Factory(t) { return new (t || StepManagerService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(NgFlowchartStepRegistry)); };
StepManagerService.ɵprov = ɵɵdefineInjectable({ factory: function StepManagerService_Factory() { return new StepManagerService(ɵɵinject(ComponentFactoryResolver), ɵɵinject(NgFlowchartStepRegistry)); }, token: StepManagerService, providedIn: "root" });
StepManagerService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: NgFlowchartStepRegistry }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepManagerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: NgFlowchartStepRegistry }]; }, null); })();

class CanvasFlow {
    constructor() {
        this.allSteps = [];
    }
    hasRoot() {
        return !!this.rootStep;
    }
}
class NgFlowchartCanvasService {
    constructor(drag, options, renderer, stepmanager) {
        this.drag = drag;
        this.options = options;
        this.renderer = renderer;
        this.stepmanager = stepmanager;
        this.isDragging = false;
        this.flow = new CanvasFlow();
        this._disabled = false;
        this.noParentError = {
            code: 'NO_PARENT',
            message: 'Step was not dropped under a parent and is not the root node'
        };
        window['flow'] = this.flow;
    }
    get disabled() {
        return this._disabled;
    }
    init(view) {
        this.viewContainer = view;
        this.renderer.init(view);
        this.stepmanager.init(view);
        //hack to load the css
        let ref = this.stepmanager.create({
            template: NgFlowchartStepComponent,
            type: '',
            data: null
        }, this);
        const i = this.viewContainer.indexOf(ref.hostView);
        this.viewContainer.remove(i);
    }
    moveStep(drag, id) {
        var _a;
        this.renderer.clearAllSnapIndicators(this.flow.allSteps);
        let step = this.flow.allSteps.find(step => step.nativeElement.id === id);
        let error = {};
        if (step.canDrop(this.currentDropTarget, error)) {
            if (step.isRootElement()) {
                this.renderer.updatePosition(step, drag);
                this.renderer.render(this.flow);
            }
            else if (this.currentDropTarget) {
                this.addStepToFlow(step, this.currentDropTarget, true);
                this.renderer.render(this.flow);
            }
            else {
                this.moveError(step, this.noParentError);
            }
            if (((_a = this.options.callbacks) === null || _a === void 0 ? void 0 : _a.onDropStep) && (this.currentDropTarget || step.isRootElement())) {
                this.options.callbacks.onDropStep({
                    isMove: true,
                    step: step,
                    parent: step.parent
                });
            }
        }
        else {
            this.moveError(step, error);
        }
    }
    onDrop(drag) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.renderer.clearAllSnapIndicators(this.flow.allSteps);
            if (this.flow.hasRoot() && !this.currentDropTarget) {
                this.dropError(this.noParentError);
                return;
            }
            //TODO just pass dragStep here, but come up with a better name and move the type to flow.model
            let componentRef = yield this.createStep(this.drag.dragStep);
            const dropTarget = this.currentDropTarget || null;
            let error = {};
            if (componentRef.instance.canDrop(dropTarget, error)) {
                if (!this.flow.hasRoot()) {
                    this.renderer.renderRoot(componentRef, drag);
                    this.setRoot(componentRef.instance);
                }
                else {
                    this.addChildStep(componentRef, dropTarget);
                }
                if ((_a = this.options.callbacks) === null || _a === void 0 ? void 0 : _a.onDropStep) {
                    this.options.callbacks.onDropStep({
                        step: componentRef.instance,
                        isMove: false,
                        parent: componentRef.instance.parent
                    });
                }
            }
            else {
                const i = this.viewContainer.indexOf(componentRef.hostView);
                this.viewContainer.remove(i);
                this.dropError(error);
            }
        });
    }
    onDragStart(drag) {
        this.isDragging = true;
        this.currentDropTarget = this.renderer.findAndShowClosestDrop(this.drag.dragStep, drag, this.flow.allSteps);
    }
    createStepFromType(id, type, data) {
        let compRef = this.stepmanager.createFromRegistry(id, type, data, this);
        return new Promise((resolve) => {
            let sub = compRef.instance.viewInit.subscribe(() => {
                sub.unsubscribe();
                resolve(compRef);
            });
        });
    }
    createStep(pending) {
        let componentRef;
        componentRef = this.stepmanager.create(pending, this);
        return new Promise((resolve) => {
            let sub = componentRef.instance.viewInit.subscribe(() => {
                sub.unsubscribe();
                resolve(componentRef);
            });
        });
    }
    addChildStep(componentRef, dropTarget) {
        this.addToCanvas(componentRef);
        this.addStepToFlow(componentRef.instance, dropTarget);
        this.renderer.render(this.flow);
    }
    addToCanvas(componentRef) {
        this.renderer.renderNonRoot(componentRef);
    }
    reRender(pretty) {
        this.renderer.render(this.flow, pretty);
    }
    upload(root) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.uploadNode(root);
            this.reRender(true);
        });
    }
    uploadNode(node, parentNode) {
        return __awaiter(this, void 0, void 0, function* () {
            let comp = yield this.createStepFromType(node.id, node.type, node.data);
            if (!parentNode) {
                this.setRoot(comp.instance);
                this.renderer.renderRoot(comp, null);
            }
            else {
                this.renderer.renderNonRoot(comp);
                this.flow.allSteps.push(comp.instance);
            }
            for (let i = 0; i < node.children.length; i++) {
                let child = node.children[i];
                let childComp = yield this.uploadNode(child, comp.instance);
                comp.instance.children.push(childComp);
                childComp.setParent(comp.instance, true);
            }
            return comp.instance;
        });
    }
    setRoot(step, force = true) {
        if (this.flow.hasRoot()) {
            if (!force) {
                console.warn('Already have a root and force is false');
                return;
            }
            //reparent root
            let oldRoot = this.flow.rootStep;
            this.flow.rootStep = step;
            step.zaddChild0(oldRoot);
        }
        else {
            this.flow.rootStep = step;
        }
        this.flow.allSteps.push(step);
    }
    addStepToFlow(step, dropTarget, isMove = false) {
        let added = false;
        switch (dropTarget.position) {
            case 'ABOVE':
                added = this.placeStepAbove(step, dropTarget.step);
                break;
            case 'BELOW':
                added = this.placeStepBelow(step, dropTarget.step);
                break;
            case 'LEFT':
                added = this.placeStepAdjacent(step, dropTarget.step, true);
                break;
            case 'RIGHT':
                added = this.placeStepAdjacent(step, dropTarget.step, false);
                break;
            default:
                break;
        }
        if (!isMove && added) {
            this.flow.allSteps.push(step);
        }
        return added;
    }
    placeStepBelow(newStep, parentStep) {
        return parentStep.zaddChild0(newStep);
    }
    placeStepAdjacent(newStep, siblingStep, isLeft = true) {
        if (siblingStep.parent) {
            //find the adjacent steps index in the parents child array
            const adjacentIndex = siblingStep.parent.children.findIndex(child => child.nativeElement.id == siblingStep.nativeElement.id);
            siblingStep.parent.zaddChildSibling0(newStep, adjacentIndex + (isLeft ? 0 : 1));
        }
        else {
            console.warn('Parallel actions must have a common parent');
            return false;
        }
        return true;
    }
    placeStepAbove(newStep, childStep) {
        let newParent = childStep.parent;
        if (newParent) {
            //we want to remove child and insert our newStep at the same index
            let index = newParent.removeChild(childStep);
            newStep.zaddChild0(childStep);
            //adjParent.addChild(newStep, index);
        }
        else { // new root node
            this.setRoot(newStep);
            newStep.zaddChild0(childStep);
        }
        return true;
    }
    dropError(error) {
        var _a, _b, _c, _d;
        if ((_a = this.options.callbacks) === null || _a === void 0 ? void 0 : _a.onDropError) {
            let parent = ((_b = this.currentDropTarget) === null || _b === void 0 ? void 0 : _b.position) !== 'BELOW' ? (_c = this.currentDropTarget) === null || _c === void 0 ? void 0 : _c.step.parent : (_d = this.currentDropTarget) === null || _d === void 0 ? void 0 : _d.step;
            this.options.callbacks.onDropError({
                step: this.drag.dragStep,
                parent: parent || null,
                error: error
            });
        }
    }
    moveError(step, error) {
        var _a, _b, _c, _d;
        if ((_a = this.options.callbacks) === null || _a === void 0 ? void 0 : _a.onMoveError) {
            let parent = ((_b = this.currentDropTarget) === null || _b === void 0 ? void 0 : _b.position) !== 'BELOW' ? (_c = this.currentDropTarget) === null || _c === void 0 ? void 0 : _c.step.parent : (_d = this.currentDropTarget) === null || _d === void 0 ? void 0 : _d.step;
            this.options.callbacks.onMoveError({
                step: {
                    instance: step,
                    type: step.type,
                    data: step.data
                },
                parent: parent,
                error: error
            });
        }
    }
}
NgFlowchartCanvasService.ɵfac = function NgFlowchartCanvasService_Factory(t) { return new (t || NgFlowchartCanvasService)(ɵngcc0.ɵɵinject(DropDataService), ɵngcc0.ɵɵinject(OptionsService), ɵngcc0.ɵɵinject(CanvasRendererService), ɵngcc0.ɵɵinject(StepManagerService)); };
NgFlowchartCanvasService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgFlowchartCanvasService, factory: NgFlowchartCanvasService.ɵfac });
NgFlowchartCanvasService.ctorParameters = () => [
    { type: DropDataService },
    { type: OptionsService },
    { type: CanvasRendererService },
    { type: StepManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgFlowchartCanvasService, [{
        type: Injectable
    }], function () { return [{ type: DropDataService }, { type: OptionsService }, { type: CanvasRendererService }, { type: StepManagerService }]; }, null); })();

class NgFlowchartCanvasDirective {
    constructor(canvasEle, viewContainer, canvas, optionService) {
        this.canvasEle = canvasEle;
        this.viewContainer = viewContainer;
        this.canvas = canvas;
        this.optionService = optionService;
        this._disabled = false;
        this.canvasEle.nativeElement.classList.add(CONSTANTS.CANVAS_CLASS);
        this.createCanvasContent(this.viewContainer);
    }
    onDrop(event) {
        if (this._disabled) {
            return;
        }
        const type = event.dataTransfer.getData('type');
        if ('FROM_CANVAS' == type) {
            this.canvas.moveStep(event, event.dataTransfer.getData('id'));
        }
        else {
            this.canvas.onDrop(event);
        }
    }
    onDragOver(event) {
        event.preventDefault();
        if (this._disabled) {
            return;
        }
        this.canvas.onDragStart(event);
    }
    onResize(event) {
        if (this._options.centerOnResize) {
            this.canvas.reRender(true);
        }
    }
    set callbacks(callbacks) {
        this.optionService.setCallbacks(callbacks);
    }
    set options(options) {
        this.optionService.setOptions(options);
        this._options = this.optionService.options;
        this.canvas.reRender();
    }
    set disabled(val) {
        this._disabled = val !== false;
        if (this.canvas) {
            this.canvas._disabled = this._disabled;
        }
    }
    get disabled() {
        return this._disabled;
    }
    ngOnInit() {
        this.canvas.init(this.viewContainer);
        if (!this._options) {
            this.options = new NgFlowchart.Options();
        }
        this.canvas._disabled = this._disabled;
    }
    createCanvasContent(viewContainer) {
        let canvasEle = viewContainer.element.nativeElement;
        let canvasContent = document.createElement('div');
        canvasContent.id = CONSTANTS.CANVAS_CONTENT_ID;
        canvasContent.classList.add(CONSTANTS.CANVAS_CONTENT_CLASS);
        canvasEle.appendChild(canvasContent);
    }
    /**
     * Returns the Flow object representing this flow chart.
     */
    getFlow() {
        return new NgFlowchart.Flow(this.canvas);
    }
}
NgFlowchartCanvasDirective.ɵfac = function NgFlowchartCanvasDirective_Factory(t) { return new (t || NgFlowchartCanvasDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(NgFlowchartCanvasService), ɵngcc0.ɵɵdirectiveInject(OptionsService)); };
NgFlowchartCanvasDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgFlowchartCanvasDirective, selectors: [["", "ngFlowchartCanvas", ""]], hostVars: 1, hostBindings: function NgFlowchartCanvasDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("drop", function NgFlowchartCanvasDirective_drop_HostBindingHandler($event) { return ctx.onDrop($event); })("dragover", function NgFlowchartCanvasDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("resize", function NgFlowchartCanvasDirective_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled);
    } }, inputs: { callbacks: ["ngFlowchartCallbacks", "callbacks"], options: ["ngFlowchartOptions", "options"], disabled: "disabled" }, features: [ɵngcc0.ɵɵProvidersFeature([
            NgFlowchartCanvasService,
            OptionsService,
            CanvasRendererService
        ])] });
NgFlowchartCanvasDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: ViewContainerRef },
    { type: NgFlowchartCanvasService },
    { type: OptionsService }
];
NgFlowchartCanvasDirective.propDecorators = {
    onDrop: [{ type: HostListener, args: ['drop', ['$event'],] }],
    onDragOver: [{ type: HostListener, args: ['dragover', ['$event'],] }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }],
    callbacks: [{ type: Input, args: ['ngFlowchartCallbacks',] }],
    options: [{ type: Input, args: ['ngFlowchartOptions',] }],
    disabled: [{ type: Input, args: ['disabled',] }, { type: HostBinding, args: ['attr.disabled',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgFlowchartCanvasDirective, [{
        type: Directive,
        args: [{
                selector: '[ngFlowchartCanvas]',
                providers: [
                    NgFlowchartCanvasService,
                    OptionsService,
                    CanvasRendererService
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ViewContainerRef }, { type: NgFlowchartCanvasService }, { type: OptionsService }]; }, { onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }], onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], callbacks: [{
            type: Input,
            args: ['ngFlowchartCallbacks']
        }], options: [{
            type: Input,
            args: ['ngFlowchartOptions']
        }], disabled: [{
            type: Input,
            args: ['disabled']
        }, {
            type: HostBinding,
            args: ['attr.disabled']
        }] }); })();

class NgFlowchartStepDirective {
    constructor(element, data) {
        this.element = element;
        this.data = data;
        this.element.nativeElement.setAttribute('draggable', 'true');
    }
    onDragStart(event) {
        this.data.setDragStep(this.flowStep);
        event.dataTransfer.setData('type', 'FROM_PALETTE');
    }
    onDragEnd(event) {
        this.data.setDragStep(null);
    }
    ngAfterViewInit() {
    }
}
NgFlowchartStepDirective.ɵfac = function NgFlowchartStepDirective_Factory(t) { return new (t || NgFlowchartStepDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DropDataService)); };
NgFlowchartStepDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgFlowchartStepDirective, selectors: [["", "ngFlowchartStep", ""]], hostBindings: function NgFlowchartStepDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dragstart", function NgFlowchartStepDirective_dragstart_HostBindingHandler($event) { return ctx.onDragStart($event); })("dragend", function NgFlowchartStepDirective_dragend_HostBindingHandler($event) { return ctx.onDragEnd($event); });
    } }, inputs: { flowStep: ["ngFlowchartStep", "flowStep"] } });
NgFlowchartStepDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: DropDataService }
];
NgFlowchartStepDirective.propDecorators = {
    onDragStart: [{ type: HostListener, args: ['dragstart', ['$event'],] }],
    onDragEnd: [{ type: HostListener, args: ['dragend', ['$event'],] }],
    flowStep: [{ type: Input, args: ['ngFlowchartStep',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgFlowchartStepDirective, [{
        type: Directive,
        args: [{
                selector: '[ngFlowchartStep]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: DropDataService }]; }, { onDragStart: [{
            type: HostListener,
            args: ['dragstart', ['$event']]
        }], onDragEnd: [{
            type: HostListener,
            args: ['dragend', ['$event']]
        }], flowStep: [{
            type: Input,
            args: ['ngFlowchartStep']
        }] }); })();

class NgFlowchartModule {
}
NgFlowchartModule.ɵfac = function NgFlowchartModule_Factory(t) { return new (t || NgFlowchartModule)(); };
NgFlowchartModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgFlowchartModule });
NgFlowchartModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgFlowchartModule, [{
        type: NgModule,
        args: [{
                declarations: [NgFlowchartCanvasDirective, NgFlowchartStepDirective, NgFlowchartStepComponent, NgFlowchartArrowComponent],
                imports: [
                    CommonModule
                ],
                exports: [NgFlowchartCanvasDirective, NgFlowchartStepDirective, NgFlowchartStepComponent, NgFlowchartArrowComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgFlowchartModule, { declarations: function () { return [NgFlowchartCanvasDirective, NgFlowchartStepDirective, NgFlowchartStepComponent, NgFlowchartArrowComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgFlowchartCanvasDirective, NgFlowchartStepDirective, NgFlowchartStepComponent, NgFlowchartArrowComponent]; } }); })();

/*
 * Public API Surface of ng-flowchart
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgFlowchart, NgFlowchartCanvasDirective, NgFlowchartModule, NgFlowchartStepComponent, NgFlowchartStepDirective, NgFlowchartStepRegistry, NgFlowchartCanvasService as ɵa, DropDataService as ɵb, OptionsService as ɵc, CanvasRendererService as ɵd, StepManagerService as ɵe, NgFlowchartArrowComponent as ɵf };

